{
  "next": "Seuraava",
  "nextStep": "Seuraava: {step}",
  "back": "Takaisin",
  "backToStart": "Takaisin etusivulle",
  "submit": "Lähetä",
  "submitContinue": "Jatka",
  "submitNextStepNote": "Rekisteröi jäsenhakemuksesi. Seuraavassa vaiheessa valitset, miten suoraveloitus aktivoidaan.",
  "donationTypeMonthly": "Kuukausittain",
  "donationTypeSingle": "Kertalahjoitus",
  "amountLabel": "Summa",
  "customAmount": "Muu summa",
  "minAmount": "Vähimmäissumma on {min} {currency}",
  "perMonth": "{amount} kr/kk",
  "firstName": "Etunimi",
  "lastName": "Sukunimi",
  "email": "Sähköposti",
  "mobile": "Matkapuhelinnumero",
  "ssn": "Henkilötunnus",
  "ssnPlaceholder": "VVVVKKPP-NNNN",
  "ssnHint": "Esimerkiksi 19940906-2388. Käytämme sitä lahjoituksesi kirjaamiseen ja postiosoitteesi hakemiseen.",
  "membershipSsnHint": "Esimerkiksi 19940906-2388. Käytämme sitä jäsenyytesi kirjaamiseen ja postiosoitteesi hakemiseen.",
  "ssnMissingHelp": "Eikö sinulla ole ruotsalaista henkilötunnusta, tai et halua antaa sitä? Ota yhteyttä lahjoittajapalveluumme, niin autamme:",
  "birthDate": "Syntymäaika",
  "birthDateHint": "Syntymäaika muodossa vvvv-kk-pp, jotta voimme varmistaa, että olet vähintään 18-vuotias.",
  "ssnOrBirthdateHint": "Eikö sinulla ole ruotsalaista henkilötunnusta? Anna sen sijaan syntymäaikasi.",
  "birthDatePlaceholder": "vvvv-kk-pp",
  "selectCountry": "Valitse maa",
  "street": "Katuosoite",
  "postcode": "Postinumero",
  "city": "Postitoimipaikka",
  "country": "Maa",
  "consentHeader": "Allekirjoita suoraveloitusvaltuutus",
  "consentSubtitle": "Allekirjoita BankID:llä tai saat valtuutuksen postitse",
  "consentBankid": "Allekirjoita BankID:llä",
  "consentPostal": "Saat valtuutuksen postitse",
  "bankidStarting": "BankID käynnistyy …",
  "bankidPending": "Avaa BankID-sovellus ja allekirjoita",
  "bankidPendingIdentify": "Avaa BankID-sovellus ja tunnistaudu",
  "bankidComplete": "Allekirjoitus valmis",
  "bankidFailed": "Allekirjoitus keskeytettiin",
  "bankidRetry": "Yritä uudelleen",
  "openBankid": "Avaa BankID",
  "errorGeneric": "Jokin meni vikaan. Yritä uudelleen.",
  "formClosed": "Keräys on suljettu.",
  "formTryAgain": "Jokin meni hetkellisesti vikaan. Yritä hetken kuluttua uudelleen.",
  "errorModalTitle": "Voi ei, jokin meni vikaan!",
  "errorModalRetry": "Yritä uudelleen",
  "errorModalContact": "Voit ottaa yhteyttä lahjoittajapalveluumme:",
  "alreadyMemberTitle": "Olet jo jäsen",
  "required": "Tämä kenttä on pakollinen",
  "invalidEmail": "Virheellinen sähköpostiosoite",
  "invalidClearing": "Clearing-numerossa on oltava 4 numeroa",
  "invalidAccount": "Tilinumerossa on oltava 4–12 numeroa",
  "invalidSsn": "Virheellinen henkilötunnus",
  "invalidMobile": "Virheellinen matkapuhelinnumero",
  "invalidPostcode": "Virheellinen postinumero",
  "minorDisclaimer": "Kuukausilahjoittajaksi ryhtyäksesi sinun on oltava vähintään 18-vuotias. Voit sen sijaan ",
  "minorLinkYouth": "liittyä vuosijäseneksi.",
  "minorLinkChild": "liittyä Rädda Djuren -kerhoon.",
  "giftTitle": "Minkä tervetuliaislahjan haluaisit?",
  "giftSubtitle": "Lahja lähetetään sinulle postitse",
  "skipGift": "En halua lahjaa",
  "enlargeGiftImage": "Näytä suurempi kuva: {title}",
  "chooseThisGift": "Valitse lahja",
  "bankidSignMessage": "Hyväksyn {amount} kruunun kuukausittaisen lahjoituksen Djurens Rättille suoraveloituksena (autogiro). Voin perua sen milloin tahansa ottamalla yhteyttä Djurens Rättiin.",
  "bankidSignMessageNoAmount": "Hyväksyn suoraveloitusvaltuutuksen (autogiro) Djurens Rättille. Voin perua sen milloin tahansa ottamalla yhteyttä Djurens Rättiin.",
  "thankYouTitle": "Kiitos tuestasi!",
  "thankYouTitleCompany": "Kiitos tuestanne!",
  "lookupCta": "Hae tietoni",
  "lookupPending": "Haetaan …",
  "lookupNotFound": "Tietoja ei löytynyt – täytä ne itse",
  "consentLinkNotFound": "Tällä linkillä ei löytynyt allekirjoitettavaa suostumusta. Tarkista, että käytit koko linkkiä viestistämme, tai ota yhteyttä, niin autamme.",
  "lookupConfirm": "Löysimme tietosi:",
  "lookupManual": "Täytä tiedot itse",
  "lookupInstead": "Hae tiedot puolestani",
  "enterManually": "Syötä tilinumero itse",
  "manualFallbackPrompt": "Haluatko mieluummin",
  "manualFallbackLink": "syöttää tilitietosi itse",
  "accountFetchPrompt": "Miten haluat antaa tilitietosi?",
  "useAccountConfirm": "Käytä tätä tiliä",
  "bank": "Pankki",
  "bankSelect": "Valitse pankkisi",
  "bankOther": "Muu pankki",
  "fetchAccounts": "Hae tili pankkisi kautta",
  "fetchingAccounts": "Haetaan tiliä …",
  "accountsFailed": "Tiliä ei voitu hakea",
  "clearing": "Clearing-numero",
  "account": "Tilinumero",
  "changeAccountPrefix": "Väärä tili? Voit",
  "changeAccountManual": "syöttää sen itse",
  "changeAccountOr": "tai",
  "changeAccountFetch": "hakea toisen tilin",
  "clearingHint": "Yleensä 4 numeroa. Sparbankernan/Swedbankin numerossa on 5 (NNNN-N) – syötä se ilman väliviivaa.",
  "sparbankWarning": "Varmista, että valitset oikean näistä: Sparbanken Syd, Swedbank tai Swedbank Sparbankerna. Jos yksi vaihtoehto ei toimi, kokeile toista.",
  "flowTitle": "Ryhdy kuukausilahjoittajaksi",
  "progressLabel": "Edistyminen",
  "stepOf": "Vaihe {step}/{total}",
  "stepAmount": "Summa",
  "stepGift": "Lahja",
  "stepDetails": "Tietosi",
  "stepAddress": "Osoite",
  "stepConsent": "Valtuutus",
  "stepPayment": "Maksu",
  "thankYouBody": "Olet nyt kuukausilahjoittaja. Yhdessä teemme eläinten hyväksi todellisen muutoksen.",
  "thankYouBodyCompany": "Olette nyt kuukausilahjoittaja. Yhdessä teemme eläinten hyväksi todellisen muutoksen.",
  "donate": "Lahjoita",
  "donationFlowTitle": "Lahjoita",
  "choosePayment": "Miten haluat maksaa?",
  "choosePaymentCompany": "Miten haluatte maksaa?",
  "paySwish": "Swish",
  "paySwishDesc": "Maksa heti Swishillä",
  "payCard": "Kortti",
  "payCardDesc": "Maksa kortilla",
  "payPostal": "Lasku",
  "payPostalDesc": "Saat laskun postitse",
  "redirecting": "Siirryt maksamaan …",
  "redirectingCompany": "Siirrytte maksamaan …",
  "donationCancelled": "Maksu peruttiin. Voit yrittää uudelleen.",
  "donationThankYouTitle": "Kiitos lahjoituksestasi!",
  "donationThankYouTitleCompany": "Kiitos lahjoituksestanne!",
  "donationThankYouBody": "Lahjoituksesi tekee eläinten hyväksi todellisen muutoksen.",
  "donationPostalBody": "Laskusi lähetetään sinulle postitse. Kiitos lahjoituksestasi!",
  "integrityText": "Tallennamme antamasi tiedot, jotta voimme hoitaa jäsenyytesi ja pitää sinut ajan tasalla työstämme eläinten hyväksi. Käsittelemme tietoja tietosuoja-asetuksen mukaisesti, mikä tarkoittaa, että takaamme tietojesi suojan emmekä luovuta niitä kenellekään muulle.",
  "integrityTextDonation": "Tallennamme antamasi tiedot, jotta voimme käsitellä lahjoituksesi ja pitää sinut ajan tasalla työstämme eläinten hyväksi. Käsittelemme tietoja tietosuoja-asetuksen mukaisesti, mikä tarkoittaa, että takaamme tietojesi suojan emmekä luovuta niitä kenellekään muulle.",
  "integrityTextDonationCompany": "Tallennamme antamanne tiedot, jotta voimme käsitellä lahjoituksenne ja pitää teidät ajan tasalla työstämme eläinten hyväksi. Käsittelemme tietoja tietosuoja-asetuksen mukaisesti, mikä tarkoittaa, että takaamme tietojenne suojan emmekä luovuta niitä kenellekään muulle.",
  "integrityTextPetition": "Tallennamme antamasi tiedot, jotta voimme rekisteröidä allekirjoituksesi ja pitää sinut ajan tasalla työstämme eläinten hyväksi. Nimesi ja mahdollinen kommenttisi muodostavat allekirjoituksen, jonka luovutamme kampanjassa. Käsittelemme tietoja tietosuoja-asetuksen mukaisesti, mikä takaa, että ne on suojattu eikä niitä luovuteta muulla tavoin.",
  "integrityTextActivist": "Tallennamme antamasi tiedot, jotta voimme rekisteröidä sinut digitaaliseksi vapaaehtoiseksi ja pitää sinut ajan tasalla työstämme eläinten hyväksi. Käsittelemme tietoja tietosuoja-asetuksen mukaisesti, mikä tarkoittaa, että takaamme tietojesi suojan emmekä luovuta niitä kenellekään muulle.",
  "integrityMore": "Lue lisää tietosuojaselosteestamme",
  "integrityMoreLink": "tietosuojaselosteestamme",
  "integrityUrl": "https://project1882.org/integrity",
  "annualFlowTitle": "Liity vuosijäseneksi",
  "stepCategory": "Jäsenyys",
  "chooseCategory": "Minkä jäsenyyden haluat?",
  "categoryOrdinary": "Tavallinen jäsenmaksu: 330 kr",
  "categoryOrdinaryDesc": "Vahvin tuki eläimille❤️ Liity mukaan ja tee eläinten hyväksi vielä suurempi muutos.",
  "categoryReduced": "Alennettu jäsenmaksu: 150 kr",
  "categoryReducedDesc": "Sinulle, joka olet 18–25-vuotias, eläkeläinen tai saat sairauskorvausta.",
  "categoryYouth": "Maksuton jäsenyys: 0 kr",
  "categoryYouthDesc": "Sinulle, joka olet 14–17-vuotias ja haluat toimia eläinten puolesta.",
  "membershipTabDjurensRatt": "Djurens Rätt",
  "membershipTabChild": "Lapsille",
  "membershipDjurensRattTitle": "Djurens Rättin jäsenyys",
  "membershipDjurensRattSubtitle": "Jäsenyyteen kuuluu 4 jäsenlehteä vuodessa. Jäsenyys uusiutuu vuosittain.",
  "membershipChildTitle": "Rädda Djuren -kerhon jäsenyys",
  "membershipChildSubtitle": "Vuoden jäsenyys Rädda Djuren -kerhossa on täydellinen lahja eläimistä välittävälle lapselle. Siihen kuuluu 5 jäsenlehteä vuodessa ja lahja, jonka voit antaa uudelle jäsenelle.",
  "membershipChildNote": "Jatka alla olevalla painikkeella Rädda Djuren -kerhon omalle sivustolle.",
  "youthBirthdateHint": "Anna henkilötunnuksesi tai syntymäaikasi, jotta voimme varmistaa, että olet 14–17-vuotias.",
  "youthAgeError": "Nuorisojäsenyys on 14–17-vuotiaille. Valitse toinen jäsenyys.",
  "youthFreeNote": "Nuorisojäsenyys on maksuton – sinun ei tarvitse maksaa mitään.",
  "becomeMember": "Liity jäseneksi",
  "annualThankYouTitle": "Tervetuloa jäseneksi!",
  "annualThankYouBody": "Kiitos, että liityit vuosijäseneksi. Yhdessä teemme eläinten hyväksi todellisen muutoksen.",
  "annualPostalBody": "Laskusi lähetetään sinulle postitse. Tervetuloa jäseneksi!",
  "annualYouthBody": "Nuorisojäsenyytesi on nyt rekisteröity. Tervetuloa!",
  "alreadyMember": "Olet jo jäsen. Ota yhteyttä lahjoittajapalveluumme, jos sinulla on kysyttävää jäsenyydestäsi.",
  "notYouFillIn": "Etkö se ole sinä? Täytä omat tietosi",
  "giftedFlowTitle": "Lahjoita",
  "stepGiftImage": "Kuva",
  "stepGiftDetails": "Tervehdys",
  "stepDelivery": "Toimitus",
  "giftcertTitle": "Vastaanottajan nimi",
  "giftcertChooseTitle": "Minkä kortin haluat lähettää?",
  "giftcertChooseSubtitle": "Valitse kuva",
  "giftcertTitlePlaceholder": "Kenelle lahja on?",
  "giftcertMessage": "Tervehdyksesi",
  "giftcertMessageHint": "Kirjoita henkilökohtainen tervehdys, joka painetaan lahjakorttiin. Muista kirjoittaa, keneltä se on. Emojeita ei voi käyttää.",
  "giftcertCharsLeft": "{count} merkkiä jäljellä",
  "giftcertMessageNoEmoji": "Tervehdyksessä ei saa olla emojeita.",
  "giftcertMessageTooLong": "Tervehdyksessä saa olla enintään {max} merkkiä.",
  "memorialHonoreeName": "Sen henkilön nimi, jota haluat muistaa",
  "memorialHonoreeNameError": "Anna sen henkilön nimi, jota haluat muistaa",
  "deliveryTitle": "Miten haluat lahjakortin toimitettavan?",
  "deliveryDigital": "Digitaalisesti",
  "deliveryPrinted": "Painettuna",
  "deliveryDigitalText": "Lahjakortti lähetetään PDF-tiedostona sähköpostiisi heti maksun jälkeen.",
  "deliveryEmail": "Sähköpostiosoitteesi",
  "deliveryPrintedText": "Painamme lahjakortin ja lähetämme sen postitse.",
  "deliveryRecipientHeading": "Kuka saa lahjakortin?",
  "deliveryMailToMe": "Lähetä lahjakortti sen sijaan minulle",
  "deliverySendWhen": "Milloin kortti lähetetään?",
  "deliverySendNow": "Mahdollisimman pian",
  "deliverySendDate": "Valitse lähetyspäivä",
  "deliverySendDateLabel": "Toimituspäivä",
  "deliveryDateInvalid": "Valitse tämä päivä tai myöhempi päivä",
  "deliveryEstimate": "Arvioitu toimitus {range}.",
  "deliveryToMeTitle": "Postitse sinulle",
  "deliveryToMeText": "Lahjakortti postitetaan sinulle, ja sen pitäisi saapua viiden arkipäivän kuluessa.",
  "deliveryToRecipientTitle": "Postitse vastaanottajalle",
  "deliveryToRecipientText": "Lahjakortti postitetaan vastaanottajalle, ja sen pitäisi saapua viiden arkipäivän kuluessa valitusta lähetyspäivästä.",
  "deliveryOr": "tai",
  "deliveryNote": "Huomaa, että toimitus kestää 3–5 arkipäivää. Postin toiminta ja pyhäpäivät voivat vaikuttaa siihen.",
  "deliveryLastDateInfo": "Jotta toimitus ehtii varmasti ennen {message}, tilaa viimeistään {date}.",
  "deliveryAfterLastDate": "Emme voi enää taata toimitusta ennen {message}.",
  "deliverySwitchDigital": "Valitse sen sijaan digitaalinen toimitus – lahjakortti lähetetään sähköpostitse heti maksun jälkeen.",
  "giftcertThankYouTitle": "Kiitos lahjastasi!",
  "giftcertThankYouBody": "Lahjakorttisi on matkalla. Kiitos, että annoit lahjan eläimille.",
  "giftcertPostalBody": "Laskusi lähetetään sinulle postitse. Kiitos lahjastasi!",
  "companyName": "Yrityksen nimi",
  "organisationNumber": "Y-tunnus",
  "invoiceEmail": "Laskutussähköposti",
  "stepCompany": "Yritys",
  "perMonthSuffix": "/kk",
  "payInvoice": "Lasku",
  "payInvoiceDesc": "Saat laskun sähköpostitse",
  "companyDonationFlowTitle": "Tee yrityslahjoitus",
  "recurringFlowTitle": "Ryhdy kuukausilahjoittajaksi",
  "companyRecurringFlowTitle": "Ryhdy kuukausilahjoittajaksi yrityksenä",
  "recurringThankYouTitle": "Kiitos kuukausittaisesta tuestasi!",
  "recurringThankYouTitleCompany": "Kiitos kuukausittaisesta tuestanne!",
  "invoiceThankYouBody": "Laskusi on matkalla. Kiitos, että tuet eläimiä!",
  "invoiceThankYouBodyCompany": "Laskunne on matkalla. Kiitos, että tuette eläimiä!",
  "giftedMembershipFlowTitle": "Lahjoita Rädda Djuren -kerhon jäsenyys",
  "stepChild": "Vastaanottaja",
  "childDetailsTitle": "Kuka liittyy jäseneksi?",
  "childFirstName": "Lapsen etunimi",
  "childLastName": "Lapsen sukunimi",
  "childBirthDate": "Lapsen syntymäaika",
  "childBirthDateHint": "Lapsen on oltava enintään 13-vuotias",
  "childMustBeChild": "Lapsen on oltava enintään 13-vuotias liittyäkseen kerhoon.",
  "sameAddressAsMe": "Lapsi asuu samassa osoitteessa kuin minä",
  "agentMustBeAdult": "Sinun on oltava vähintään 18-vuotias lahjoittaaksesi jäsenyyden.",
  "becomeChildMember": "Lahjoita jäsenyys",
  "giftedMembershipThankYouTitle": "Kiitos lahjastasi!",
  "giftedMembershipThankYouBody": "Rädda Djuren -kerhon jäsenyys on matkalla. Kiitos, että annoit lapselle mahdollisuuden auttaa eläimiä.",
  "giftedMembershipPostalBody": "Laskusi lähetetään sinulle postitse. Kiitos, että lahjoitit jäsenyyden!",
  "giftedAnnualStepRecipient": "Vastaanottaja",
  "giftedAnnualStepGiftCard": "Lahjakortti",
  "giftedAnnualRecipientTitle": "Kenelle jäsenyys on?",
  "giftedAnnualRecipientSsn": "Vastaanottajan henkilötunnus",
  "giftedAnnualRecipientLookupConfirm": "Löysimme vastaanottajan tiedot:",
  "giftedAnnualRecipientSsnHint": "Esimerkiksi 19940906-2388. Käytämme sitä jäsenyyden kirjaamiseen oikealle henkilölle ja hänen postiosoitteensa hakemiseen.",
  "giftedAnnualRecipientFirstName": "Vastaanottajan etunimi",
  "giftedAnnualRecipientLastName": "Vastaanottajan sukunimi",
  "giftedAnnualRecipientBirthDate": "Vastaanottajan syntymäaika",
  "giftedAnnualSameAddress": "Vastaanottaja asuu samassa osoitteessa kuin minä",
  "giftedAnnualCategoryTitle": "Minkä jäsenyyden vastaanottaja saa?",
  "giftedAnnualPresentTitle": "Minkä tervetuliaislahjan haluat antaa?",
  "giftedAnnualGiftCardTitle": "Minkä lahjakortin haluat antaa?",
  "giftedAnnualGiftCardSubtitle": "Lahjakortti lähetetään sinulle postitse.",
  "giftedAnnualBuyerTitle": "Kuka sinä olet, joka lahjoitat jäsenyyden?",
  "giftedAnnualSubmit": "Lahjoita jäsenyys",
  "giftedAnnualThankYouTitle": "Kiitos, että lahjoitit jäsenyyden!",
  "giftedAnnualThankYouBody": "Yhdessä teemme eläinten hyväksi todellisen muutoksen.",
  "giftedAnnualPostalBody": "Lasku lähetetään sinulle postitse.",
  "giftedAnnualYouthBody": "Nuorisojäsenyys on rekisteröity.",
  "giftedAnnualAlreadyMember": "Vastaanottaja on jo Djurens Rättin jäsen. Ota yhteyttä lahjoittajapalveluumme, jos sinulla on kysyttävää.",
  "raiseAmountTitle": "Korota kuukausisummaasi",
  "raiseAmountIntro": "Djurens Rättin kuukausilahjoittajana voit helposti korottaa kuukausisummaasi.",
  "raiseAmountIdentifyTitle": "Tunnistaudu",
  "raiseAmountIdentifyIntro": "Kirjaudu BankID:llä, niin haemme jäsenyytesi.",
  "raiseAmountIdentifyCta": "Tunnistaudu BankID:llä",
  "raiseAmountChooseTitle": "Valitse uusi kuukausisumma",
  "raiseAmountCurrent": "Nykyinen summasi: {amount} kr/kk",
  "raiseAmountSameError": "Summa on sama kuin aiemmin. Valitse toinen summa.",
  "raiseAmountMustBeHigher": "Lahjoitat jo {current} {currency}/kk. Valitse suurempi summa korottaaksesi sitä.",
  "raiseAmountMustBeHigherUnknown": "Uuden summan on oltava nykyistä suurempi.",
  "raiseAmountUnavailable": "Emme voineet varmistaa, meneekö muutos läpi. Yritä hetken kuluttua uudelleen – saman summan lähettäminen uudelleen ei muuta mitään, jos muutos on jo tehty.",
  "raiseAmountNotFound": "Emme löytäneet jäsenyyttäsi. Tarkista tietosi ja yritä uudelleen.",
  "raiseAmountSubmit": "Vahvista uusi summa",
  "raiseAmountSuccessTitle": "Kuukausisummasi on muuttunut",
  "raiseAmountSuccessBody": "Uusi kuukausilahjoituksesi on {amount} kr/kk. Kiitos tuestasi!",
  "raiseAmountAltToggle": "Identify yourself another way",
  "raiseAmountHelp": "Stuck? Email",
  "raiseAmountAltMemberNumberHint": "Your member number is in our letters and on the back of the Djurens Rätt magazine.",
  "raiseAmountAltMobileHint": "The number you have registered with us, e.g. +46xxxxxxxxx.",
  "raiseAmountAltCodeHint": "The six-digit code in the text message.",
  "raiseAmountAltEmailHint": "The address you have registered with us.",
  "raiseAmountAltSsnHint": "For example 19940906-2388, used to confirm it is you.",
  "raiseAmountAltInvalidCode": "The code is six digits.",
  "raiseAmountAltTabSms": "Text code",
  "raiseAmountAltTabEmail": "Email link",
  "raiseAmountAltTabMember": "Member number",
  "raiseAmountAltMobileLabel": "Mobile number",
  "raiseAmountAltSmsCta": "Send code",
  "raiseAmountAltSmsSent": "If we have {mobile}, we have sent a code to it. The code is valid for 10 minutes.",
  "raiseAmountAltCodeLabel": "Code",
  "raiseAmountAltCodeCta": "Sign in",
  "raiseAmountAltWrongCode": "The code is not right. Check it and try again.",
  "raiseAmountAltCodeExpired": "The code has expired. Ask for a new one.",
  "raiseAmountAltEmailLabel": "Email address",
  "raiseAmountAltEmailCta": "Send link",
  "raiseAmountAltEmailSent": "If we have {email}, we have sent a link to it. The link is valid for 30 minutes.",
  "raiseAmountAltLinkExpired": "The link has expired. Sign in again below.",
  "raiseAmountSignedInAs": "Signed in as {name}",
  "raiseAmountNotYou": "Not you?",
  "raiseAmountAltMemberNumberLabel": "Membership number",
  "raiseAmountAltSsnLabel": "Personal identity number",
  "raiseAmountAltMemberCta": "Sign in",
  "raiseAmountAltMemberNoMatch": "The membership number and personal identity number do not match. Check them and try again.",
  "raiseAmountAltRateLimited": "You have tried too many times. Wait a while and try again.",
  "raiseAmountAltChangeMobile": "Change number",
  "raiseAmountAltUnavailable": "We couldn't sign you in just now. Please try again in a moment.",
  "recommended": "Suositeltu",
  "surveyBack": "Takaisin",
  "surveyBlixtCta": "Tilaa Blixtmail",
  "surveyBlixtSendsTo": "Blixtmail lähetetään osoitteeseen {email}.",
  "surveyBlixtTitle": "Ryhdy Blixtiksi – toimi eläinten puolesta digitaalisesti!",
  "surveyBlixtBody": "Digitaalisena vapaaehtoisena teet nopeita verkkotekoja eläinten puolesta – pieniä tehtäviä, jotka tekevät todellisen muutoksen. Saat tehtävät sähköpostitse ja voit käyttää myös BlixtAppia, johon tulee jatkuvasti uusia tehtäviä.",
  "surveyBlixtMoreLabel": "Mitä digitaalinen vapaaehtoinen tekee?",
  "surveyBlixtFact1": "Allekirjoittaa vetoomuksia eläinten puolesta",
  "surveyBlixtFact2": "Lähettää pikaviestejä yrityksille ja päättäjille",
  "surveyBlixtFact3": "Jakaa ja levittää viestejä sosiaalisessa mediassa",
  "surveyBlixtDone": "Kiitos! Olet nyt Blixt.",
  "surveyBlixtOpenApp": "Avaa BlixtApp",
  "surveyBlixtError": "Jokin meni vikaan. Yritä uudelleen.",
  "surveyChannelEmail": "sähköposti",
  "surveyQuestionBadge": "Kysymys {n}",
  "surveyAmountChip": "{amount} kr",
  "surveyAmountGroupSwish": "Lahjoita kerran Swishillä",
  "surveyAmountGroupMonthly": "Lahjoita kuukausittain",
  "surveyShareDecline": "Ei kiitos",
  "surveyShareVia": "kautta",
  "surveyShareLinkLabel": "Jaettava linkki",
  "surveyShareCopy": "Kopioi linkki",
  "surveyShareCopied": "Linkki kopioitu",
  "opensInNewTab": "(avautuu uuteen välilehteen)",
  "petitionStepMessage": "Viesti",
  "petitionMessagePlaceholder": "Kirjoita viesti (vapaaehtoinen)",
  "petitionMessageLabel": "Viestisi",
  "petitionNewsletterOptIn": "Kyllä, lähettäkää minulle uutiskirje",
  "petitionSubmit": "Allekirjoita vetoomus",
  "petitionThankYouTitle": "Kiitos allekirjoituksestasi!",
  "petitionThankYouBody": "Allekirjoituksesi on tallennettu.",
  "petitionAlreadySigned": "Olet jo allekirjoittanut.",
  "petitionErrorMessage": "Jokin meni vikaan. Yritä uudelleen.",
  "loading": "Ladataan",
  "secondAskSigningAs": "Allekirjoitat nimellä",
  "secondAskPetitionTitle": "Allekirjoita vetoomus",
  "petitionMotivationLabel": "Kerro, miksi allekirjoitat (vapaaehtoinen, näytetään tällä sivulla)",
  "petitionBlixtmailOptIn": "Kyllä, haluan saada Blixtmailin kerran viikossa ja vinkkejä teoista eläinten puolesta.",
  "petitionProgressLabel": "{count} allekirjoitusta – seuraava tavoitteemme on {goal}!",
  "secondAskAlreadySigned": "Olet jo allekirjoittanut",
  "secondAskDonateWithSwish": "Maksa {amount} {currency} Swishillä",
  "secondAskDonateWithCard": "Maksa {amount} {currency} kortilla",
  "secondAskSwishTo": "Swish-maksupyyntö lähetetään numeroon {mobile}.",
  "secondAskSwishChange": "Vaihda numero",
  "secondAskSwishWrongNumber": "Väärä numero? Vaihda se",
  "secondAskPaymentCancelled": "Maksu peruttiin. Yritä uudelleen tai vaihda numero, jos se oli väärä.",
  "secondAskBecomeMonthly": "Ryhdy kuukausilahjoittajaksi {amount} kr/kk",
  "secondAskRaiseTo": "Korota summaan {amount} kr/kk",
  "secondAskCurrentMonthly": "Lahjoitat nyt {amount} kr/kk",
  "secondAskDonorAs": "Lahjoitat nimellä",
  "secondAskMembershipSuccess": "Tervetuloa kuukausilahjoittajaksi!",
  "secondAskRaiseSuccess": "Kuukausisummasi on päivitetty",
  "secondAskDonationTitle": "Tue eläimiä lahjoituksella",
  "secondAskMonthlyTitle": "Ryhdy kuukausilahjoittajaksi",
  "shopBuyNow": "Osta nyt",
  "shopSoldOut": "Loppuunmyyty",
  "shopViewInStore": "Näytä kaupassa",
  "shopVariant": "Vaihtoehto",
  "shopNoProducts": "Ei näytettäviä tuotteita juuri nyt.",
  "shopMemberPrice": "Jäsenhinta",
  "bankidQrEnlargedTitle": "Skannaa QR-koodi",
  "bankidQrEnlargedLabel": "Suurennettu BankID-QR-koodi",
  "bankidQrEnlargedHint": "Avaa puhelimesi BankID-sovellus ja skannaa koodi.",
  "bankidQrAlt": "QR-koodi, joka skannataan BankID-sovelluksella",
  "bankidEnlargeQr": "Suurenna QR-koodi",
  "bankidExtend": "Anna lisää aikaa",
  "bankidExpired": "Aika loppui",
  "close": "Sulje",
  "actStepStart": "Tiedot",
  "actStepAmount": "Lahjoitus",
  "actStepDetails": "Henkilötiedot",
  "actStepAddress": "Postiosoite",
  "actStepPayment": "Maksutavat",
  "actAmountTitle": "Kuinka paljon haluaisit lahjoittaa eläinten hyväksi?",
  "actDetailsTitle": "Maksutietosi",
  "actDetailsSubtitle": "Täytä tietosi",
  "actAddressTitle": "Mikä on postiosoitteesi?",
  "actAddressSubtitle": "Haetut tiedot",
  "actAddressSubtitleManual": "Täytä tietosi",
  "actPaymentTitle": "Miten haluat maksaa lahjoituksesi eläimille?",
  "actPaymentSubtitle": "Valitse maksutapa",
  "actPaymentTitleSingle": "Kaikki on valmista",
  "actPaymentSubtitleSingle": "Tehdään lahjoitus eläinten hyväksi",
  "actAmountEyebrow": "Lahjoitukseni eläimille",
  "actAmountEyebrowCompany": "Lahjoituksemme eläimille",
  "actAmountHint": "Valitse lahjoitussumma",
  "actAmountOther": "Muu",
  "actAmountCustomLabel": "Valitse lahjoitussumma",
  "actAmountCustomLabelCompany": "Valitkaa lahjoitussumma",
  "actSingle": "Kertalahjoitus",
  "actMonthly": "Kuukausilahjoitus",
  "actSsnPlaceholder": "vvvvkkpp-nnnn",
  "actSsnHint": "Ruotsalainen henkilötunnus (personnummer), vvvvkkpp-nnnn",
  "actNoSsn": "Minulla ei ole ruotsalaista henkilötunnusta",
  "actHasSsn": "Minulla on ruotsalainen henkilötunnus",
  "actBirthDateHint": "Syntymäaika muodossa vvvv-kk-pp",
  "actMobileHint": "Anna matkapuhelinnumerosi ilman väliviivoja tai välilyöntejä, esimerkiksi +358xxxxxxxxx",
  "actFillOther": "Täytä muut tiedot",
  "actLookupName": "Nimi",
  "actLookupChangeAddress": "Täytä muut tiedot",
  "actLookupUseFetched": "Käytä haettuja tietoja",
  "actLookupBannerPending": "Haetaan tietojasi …",
  "actLookupBannerFound": "Löysimme tietosi!",
  "actLookupBannerFailed": "Osoitettasi ei voitu hakea!",
  "actPaySwish": "Swish",
  "actPaySwishDesc": "Sujuvaa ja helppoa, suosittelemme!",
  "actPayCard": "Kortti",
  "actPayCardDesc": "Veloitetaan heti, sujuvasti!",
  "actPayCardDescCompany": "Veloitetaan heti, sujuvasti!",
  "actPayPostal": "Lasku",
  "actPayPostalDesc": "Saat laskun postitse",
  "actPayBySwish": "Maksa Swishillä",
  "actPayByCard": "Maksa kortilla",
  "actPayByPostal": "Maksa",
  "actReadMore": "Lue lisää",
  "videoPlay": "Toista video",
  "videoPause": "Keskeytä video",
  "completing": "Hetkinen …",
  "actConsentTitle": "Allekirjoita suoraveloitusvaltuutus",
  "actConsentSubtitle": "Valitse, miten haluat allekirjoittaa",
  "actConsentBankid": "BankID",
  "actConsentBankidDesc": "Allekirjoita kätevästi BankID:llä",
  "actConsentPostal": "Paperilomake",
  "actConsentPostalDesc": "Saat lomakkeen postissa",
  "actBankTitle": "Hae pankkitili",
  "actBankTitleManual": "Täytä pankkitietosi",
  "actBankTitleFetched": "Haetut pankkitietosi",
  "actBankSubtitle": "Suoraveloitus toimii vain joillakin tileillä, joten tarkista pankistasi, että tilisi tukee sitä",
  "actSignTitle": "Allekirjoita BankID:llä",
  "actSignSubtitle": "Allekirjoittamalla hyväksyn nämä ehdot",
  "actConsentOtherMethod": "Valitse toinen allekirjoitustapa",
  "actMonthlyStepAmount": "Summa",
  "actMonthlyStepAddress": "Osoite",
  "actPerMonthSuffix": "/kk",
  "actStepBank": "Pankki",
  "actStepSign": "Allekirjoita"
}
